import axios from "@/plugins/axios";

let url = (data) => "/api/v1/company/employment/files".interpolate(data);

export default {
    gets(data) {
        return axios.get(url(data), data).then((result) => result.data);
    },
    get(data) {
        return axios.get(`${url(data)}/${data._id}`).then((result) => result.data);
    },
    post(data = {}, file) {
        let headers = { "Content-Type": "multipart/form-data" };

        let formData = new FormData();
        for (const key of Object.keys(data)) {
            formData.append(key, data[key]);
        }
        formData.append("file", file);

        return axios.post(`${url(data)}`, formData, { headers }).then((result) => result.data);
    },
    put(data) {
        return axios.put(`${url(data)}/${data._id}`, data).then((result) => result.data);
    },
    delete(data) {
        return axios.delete(`${url(data)}/${data._id}`).then((result) => result.data);
    },
};
